<script setup lang="ts">
import { AppLogo } from '@UI/Other/AppLogo'
import { ToastProvider } from '@UI/Toast/ToastProvider'

defineOptions({
  name: 'AuthLayout',
})

</script>

<template>
  <div class="auth-layout">
    <AppLogo />
    <slot />
  </div>
  <ToastProvider />
</template>

<style scoped lang="scss" src="@scss/layouts/auth-layout.scss" />